import { Fragment } from 'react';
import { DEPTH_STEP, useMetaContext } from '../base';
import type { GeoChartColumn } from '../types';

export const DepthGeoChartBodyColumn = ({ column }: { column: GeoChartColumn; }) => {
    const meta = useMetaContext();

    const thicksCount = Math.round(meta.depths.total / DEPTH_STEP);

    const thicks: Array<{ depth: number; y: number }> = [];

    for (let i = 0; i <= thicksCount; i += 1) {
        const depth = meta.depths.first + i * DEPTH_STEP;
        const y = meta.depths.metersToPixelsY(i * DEPTH_STEP);
        thicks.push({
            depth,
            y,
        });
    }

    return (
        <svg width={column.width} height={meta.content.height} style={{}}>
            {thicks.map(({ depth, y }, dIndex) => {
                if (dIndex === 0) {
                    return null;
                }
                return (
                    <Fragment key={dIndex}>
                        <text x={0} y={y - 5} fill="currentColor" fontSize={'14'} style={{ textAnchor: 'start' }}>
                            {-depth}
                        </text>
                        <line x1={0} y1={y} x2={column.width} y2={y} style={{ stroke: 'currentColor', strokeWidth: 0.5 }} />;
                    </Fragment>
                );
            })}
        </svg>
    );
};
